import { render, staticRenderFns } from "./SupplierAgreement.vue?vue&type=template&id=befaa892&scoped=true&"
import script from "./SupplierAgreement.vue?vue&type=script&lang=js&"
export * from "./SupplierAgreement.vue?vue&type=script&lang=js&"
import style0 from "./SupplierAgreement.vue?vue&type=style&index=0&id=befaa892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befaa892",
  null
  
)

export default component.exports